import React from 'react';
import Icon from '@ant-design/icons';

// 1. Die reine SVG-Grafik definieren
const SafariShareSvg = () => (
  <svg 
    viewBox="0 0 24 24" 
    width="1em" 
    height="1em" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    {/* Pfade für das Safari-Share-Symbol */}
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

// 2. Mit dem Ant-Design Icon-Wrapper umschließen
export const SafariShareIcon = (props) => (
  <Icon component={SafariShareSvg} {...props} />
);
